module.exports = __webpack_public_path__ + "img/index04.5208660f.jpg";